module.exports = __webpack_public_path__ + "img/bg-profesor.5994d088.png";